import { NavLink } from 'react-router-dom'
import useSWR from 'swr'
import { useAuth } from '../auth/AuthContext'
import { apiGet } from '../config/api'
import type { NotificationsListResponse } from '../types/notification'
import { IconBell } from './icons'

function bellButtonClass(isActive: boolean) {
  return `relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border transition sm:h-10 sm:w-10 ${
    isActive
      ? 'border-violet-400 bg-violet-50 text-violet-700 dark:border-violet-600 dark:bg-violet-950/50 dark:text-violet-300'
      : 'border-zinc-200/90 bg-zinc-100/80 text-zinc-600 hover:border-zinc-300 hover:text-zinc-900 dark:border-zinc-700 dark:bg-zinc-800/80 dark:text-zinc-400 dark:hover:border-zinc-600 dark:hover:text-zinc-100'
  }`
}

/** Κουδούνι ειδοποιήσεων στο header — Silver+ (`notifications` entitlement). */
export function NotificationBellButton() {
  const { user } = useAuth()
  const canNotify = (user?.entitlements ?? []).includes('notifications')

  const { data } = useSWR(
    canNotify ? 'notifications' : null,
    () => apiGet<NotificationsListResponse>('/notifications'),
    { refreshInterval: 60_000 },
  )

  const unread = data?.unreadCount ?? 0

  if (!canNotify) return null

  return (
    <NavLink
      to="/notifications"
      className={({ isActive }) => bellButtonClass(isActive)}
      title="Ειδοποιήσεις"
      aria-label={
        unread > 0
          ? `Ειδοποιήσεις, ${unread} μη αναγνωσμένες`
          : 'Ειδοποιήσεις'
      }
    >
      <IconBell className="h-5 w-5" aria-hidden />
      {unread > 0 ? (
        <span
          className="absolute -right-0.5 -top-0.5 flex h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-violet-600 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white dark:ring-zinc-950"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      ) : null}
    </NavLink>
  )
}
